import { useEffect } from 'react';
import { useLocationStore } from '@/store/location';
import { useAuth } from '@/contexts/AuthContext';

/**
 * 앱 전역에서 사용할 위치 관리 Hook
 * App.tsx에서 한 번만 호출하여 초기화
 */
export function useLocationManager() {
  const { checkAuthAndLoad } = useLocationStore();
  const { isLoading: authLoading } = useAuth();

  useEffect(() => {
    // AuthContext 로딩이 완료된 후에만 위치 데이터 로드
    if (!authLoading) {
      // 인증 상태를 확인하여 적절한 데이터 소스에서 주소 로드
      checkAuthAndLoad();
    }
  }, [authLoading, checkAuthAndLoad]);

  return null; // UI 렌더링 없음, 순수 로직만
}